import { render, staticRenderFns } from "./BloqueIndex.vue?vue&type=template&id=32fd1baa"
import script from "./BloqueIndex.vue?vue&type=script&lang=js"
export * from "./BloqueIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports